import { TermsCopy } from '@components/ui';
import Typography from '@mui/material/Typography';
export function TermsOfServiceIntro(): JSX.Element {
  return (
    <>
      <Typography component="p" sx={{ textTransform: 'uppercase', fontWeight: 700, fontSize: 20, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.termsOfServiceIntro.0" />
      </Typography>
      <TermsCopy i18nKey="termsSections.termsOfServiceIntro.1" />
    </>
  );
}
